import React from "react";
import { Link } from "react-router-dom";

/**
 * Catch-all for an address that matches no route.
 *
 * Without one, React Router renders nothing: a mistyped link, a bookmark to a
 * page that has been removed, or a stale link from an old email all produced a
 * blank white page with the URL still in the bar and no way to tell whether the
 * app was broken or the address was simply wrong.
 */
const NotFound = () => (
  <div className="notfound-page">
    <main className="notfound-main">
      <p className="notfound-code">404</p>
      <h1>We can't find that page</h1>
      <p>
        The address may have changed, or the link that brought you here may be
        out of date.
      </p>
      <div className="notfound-actions">
        <Link className="btn-filled" to="/">Go to the home page</Link>
        <Link className="notfound-secondary" to="/login">Sign in</Link>
      </div>
    </main>
  </div>
);

export default NotFound;
